import { Directive, ElementRef, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appLangSwitchText]',
  standalone: true
})
export class LangSwitchTextDirective {
  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
  ) {}

  setText(text: string): void {
    this.renderer.setProperty(this.el.nativeElement, 'textContent', text);
  }
}
